import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { useSelector } from "react-redux";

import { signalRConstants } from "../views/shared-screens/constants";
import { ENV } from "../config/env";

const { connectionUrl } = signalRConstants;

const SignalRContext = createContext();

//Build base URL for signalR
const buildURL = (url) => {
  const baseUrl = ENV.SIGNAL_R;
  return `${baseUrl}${url}`;
};

export const SignalRProvider = ({ children }) => {
  const [connection, setConnection] = useState(null);

  const { user, jwt, isAuthenticated } = useSelector(
    (state) => state.authentication
  );

  //Build connection if user is authenticated
  useEffect(() => {
    if (isAuthenticated) {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(buildURL(`${connectionUrl}${user.id}`), {
          accessTokenFactory: () => {
            return jwt;
          },
        })
        .configureLogging(signalR.LogLevel.Error)
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: () => {
            //Always return a random delay (e.g., 0-5 seconds)
            return (
              Math.random() *
              ENV.SIGNALR_RETRY_CONNECTION_TIME
            );
          },
        })
        .build();

      setConnection(newConnection);

      return () => {
        newConnection.stop().catch(() => {}); //Swallow handshake-cancel rejection on teardown
        newConnection.off(); //Unsubscribe all event listeners when disconnecting
      };
    } else if (connection) {
      connection.stop().catch(() => {}); //Swallow handshake-cancel rejection on teardown
      connection.off(); //Unsubscribe all event listeners when disconnecting
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const contextValue = useMemo(() => ({ connection }), [connection]);

  return (
    <SignalRContext.Provider value={contextValue}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
